import React from 'react'

export default function EthereumIcons() {
   return (
      <svg
         width="251"
         height="530"
         viewBox="0 0 251 530"
         className="w-100"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M38.0386 508.184H13.6066V476.024H38.0386V479.144H17.0146V490.472H37.3186V493.544H17.0146V505.064H38.0386V508.184ZM57.3537 508.184H52.2177C47.5137 508.184 44.4897 506.216 44.4897 500.648V487.4H40.2657V484.472H44.4897V478.808H47.9457V484.472H57.3537V487.4H47.9457V500.84C47.9457 504.152 49.5777 505.064 53.0337 505.064H57.3537V508.184ZM64.4989 508.184H61.0909V476.024H64.4989V491.72H64.7389C65.5069 487.736 68.5789 483.992 74.6269 483.992C81.2509 483.992 84.5629 488.408 84.5629 494.408V508.184H81.1549V494.84C81.1549 489.416 78.6109 487.112 73.2829 487.112C66.9469 487.112 64.4989 491.144 64.4989 497.048V508.184ZM101.48 508.664C93.8483 508.664 89.0003 503.864 89.0003 496.328C89.0003 489.128 93.8003 483.992 101.432 483.992C108.392 483.992 113.336 488.024 113.336 495.08C113.336 495.944 113.24 496.664 113.096 497.288H92.2163C92.4083 502.616 95.1443 505.832 101.432 505.832C107 505.832 109.592 503.768 109.592 500.312V499.976H113V500.312C113 505.256 108.104 508.664 101.48 508.664ZM101.384 486.824C95.2403 486.824 92.4563 489.992 92.2163 495.176H110.12C110.12 494.936 110.12 494.696 110.12 494.456C110.12 489.464 106.952 486.824 101.384 486.824ZM121.265 508.184H117.857V484.472H120.929V490.952H121.169C121.889 487.16 124.577 483.992 129.521 483.992C134.993 483.992 137.393 488.024 137.393 492.44V494.792H133.985V492.968C133.985 488.936 132.305 486.968 128.177 486.968C123.377 486.968 121.265 489.992 121.265 495.32V508.184ZM152.621 508.664C144.989 508.664 140.141 503.864 140.141 496.328C140.141 489.128 144.941 483.992 152.573 483.992C159.533 483.992 164.477 488.024 164.477 495.08C164.477 495.944 164.381 496.664 164.237 497.288H143.357C143.549 502.616 146.285 505.832 152.573 505.832C158.141 505.832 160.733 503.768 160.733 500.312V499.976H164.141V500.312C164.141 505.256 159.245 508.664 152.621 508.664ZM152.525 486.824C146.381 486.824 143.597 489.992 143.357 495.176H161.261C161.261 494.936 161.261 494.696 161.261 494.456C161.261 489.464 158.093 486.824 152.525 486.824ZM178.933 508.664C172.165 508.664 168.853 503.96 168.853 498.344V484.472H172.261V497.816C172.261 502.76 174.661 505.592 180.133 505.592C185.941 505.592 188.965 502.088 188.965 495.992V484.472H192.373V508.184H189.301V500.792H189.061C188.245 504.824 184.837 508.664 178.933 508.664ZM201.515 508.184H198.107V484.472H201.179V491.624H201.371C202.043 487.64 204.779 483.992 210.683 483.992C215.963 483.992 218.939 487.256 219.707 491.864H219.947C220.619 487.784 223.451 483.992 229.403 483.992C235.595 483.992 238.811 488.36 238.811 494.36V508.184H235.403V494.84C235.403 489.56 233.147 487.112 228.155 487.112C222.443 487.112 220.139 490.424 220.139 496.712V508.184H216.731V494.84C216.731 489.56 214.523 487.112 209.531 487.112C203.771 487.112 201.515 490.424 201.515 496.712V508.184Z"
            fill="#F1ECDC"
         />
         <g clipPath="url(#clip0_5116_176961)">
            <path
               d="M125.571 0.0195312L122.842 9.2955V278.463L125.571 281.187L250.516 207.333L125.571 0.0195312Z"
               fill="#F1ECDC"
            />
            <path
               d="M125.572 0.0195312L0.62793 207.333L125.572 281.188V150.542V0.0195312Z"
               fill="#F1ECDC"
            />
            <path
               d="M125.571 304.845L124.033 306.719V402.602L125.571 407.094L250.591 231.027L125.571 304.845Z"
               fill="#F1ECDC"
            />
            <path
               d="M125.572 407.093V304.843L0.62793 231.025L125.572 407.093Z"
               fill="#F1ECDC"
            />
            <path
               d="M125.571 281.187L250.514 207.333L125.571 150.543V281.187Z"
               fill="#F1ECDC"
            />
            <path
               d="M0.62793 207.332L125.57 281.187V150.542L0.62793 207.332Z"
               fill="#F1ECDC"
            />
         </g>
         <defs>
            <clippath id="clip0_5116_176961">
               <rect
                  width="250"
                  height="407.166"
                  fill="white"
                  transform="translate(0.609375 0.0195312)"
               />
            </clippath>
         </defs>
      </svg>
   )
}
